import React from 'react';
import { Paper, InputBase, IconButton, Container } from '@material-ui/core';
import { Search, MicNone } from '@material-ui/icons';
import NewsCard from '../shared/newsCard/newsCard';
import Footer from '../footer/Footer';
import { useStyles, BlogLogic, BlogService, banner_blog } from './blog.module';
import BannerInterface from '../shared/bannerInterface/bannerInterface';
const Blog = () => {
  const classes = useStyles();
  const { filteredNews, handleSearch, search, translator } =
    BlogLogic(BlogService);
  // console.log(JSON.stringify(filteredNews));

  return (
    <>
      <BannerInterface text={'eGreen Blog'} backgroundImage={banner_blog} />
      <Container maxWidth="lg">
        <div className={classes.gridSearch}>
          <Paper className={classes.search}>
            <IconButton
              type="submit"
              className={classes.iconButton}
              aria-label="ssearch"
            >
              <Search className={classes.searchIcon} />
            </IconButton>
            <InputBase
              className={classes.input}
              placeholder={translator('blog.search')}
              value={search}
              onChange={handleSearch}
            />
            <IconButton
              type="submit"
              className={classes.iconButton}
              aria-label="microfono"
            >
              <MicNone className={classes.searchIcon} />
            </IconButton>
          </Paper>
        </div>
        <div className={classes.gridnewsCard}>
          {filteredNews.map((mediaCard, i) => {
            return (
              <div key={i}>
                <NewsCard {...mediaCard} />
              </div>
            );
          })}
        </div>
      </Container>
      <Footer />
    </>
  );
};
export default Blog;
